import { render, staticRenderFns } from "./DispatchWorkflowsEmptyState.vue?vue&type=template&id=3066b65c&scoped=true"
import script from "./DispatchWorkflowsEmptyState.vue?vue&type=script&lang=js"
export * from "./DispatchWorkflowsEmptyState.vue?vue&type=script&lang=js"
import style0 from "./DispatchWorkflowsEmptyState.vue?vue&type=style&index=0&id=3066b65c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3066b65c",
  null
  
)

export default component.exports